<template>
    <div>
        <JsonLd :json="jsonld" />
      <main id="special230901">
        <!-- 特集Specialコンテンツここから-->

        <!-- KV Section ここから -->
        <section id="kv" class="kv">
          <video playsinline autoplay muted loop>
            <source src="../../../assets/luxury_travel/luxury_travel06/video/bg_main.mp4" type="video/mp4">
          </video>
          <div id="kv__black"></div><!-- kv__black -->
        </section><!-- kv -->

        <div class="kv__titleArea">
          <p class="kv__title--sub fadeIn">Luxury Travel</p>
          <h2 class="kv__title fadeIn" id="kv__title">Forged in Time: <br>Uncovering <br>Okuizumo's Steel <br>Heritage</h2>
          <p class="playVideo fadeIn" @click="openStreaksPlayer('3cdeabbb08874a7ea1972e477ef649e8')">
            <img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel06/svg/play_icon.svg" alt="">Play video
          </p>
        </div><!-- kv__titleArea -->


        <!-- Lead Section ここから -->
        <section id="lead" class="lead">

          <div class="leadSection01">

            <div class="lead__des_wrapper">
              <p class="lead__des fadeIn">In Japan, Shimane is a region synonymous with mythology. Its landmarks, such as Inasa no Hama Beach and Izumo Taisha Shrine, are proud symbols of Japan’s spiritual legacy.</p>
            </div><!-- lead__des_wrapper -->

          </div><!-- leadSection01 -->


          <div class="leadSecion02">

            <div class="leadPhotosArea1">
              <img class="lead__photos01 fadeIn" src="../../../assets/luxury_travel/luxury_travel06/lead01.jpg" alt="">
              <img class="lead__photos02 fadeIn" src="../../../assets/luxury_travel/luxury_travel06/lead02.jpg" alt="">
            </div><!-- leadPhotosArea1 -->

            <div class="lead__des_wrapper2">
              <p class="lead__des fadeIn">Venturing beyond the realm of myths, the Okuizumo area invites visitors to explore another facet of this captivating region. The land is rich in iron sand, essential to the traditional <i>tatara</i> method of ironmaking. <br><br>Precious steel made through this process was sent to swordsmiths all over the country to be forged into <i>katana</i> swords. <i>Tatara</i> traditional ironmaking is an invaluable cultural legacy, deeply ingrained in the region's history, culture, and craftsmanship.</p>
            </div><!-- lead__des_wrapper2 -->

          </div><!-- leadSecion02 -->

          <div class="lead__largeImage">
            <img src="../../../assets/luxury_travel/luxury_travel06/large_dammy.png" alt="" class="">
          </div><!-- lead__largeImage -->


          <div class="leadSection03">

            <div class="lead__des_wrapper3">
              <p class="lead__des fadeIn">From its gorgeous <i>ryokan</i> inns to the landscape and the artisans that call this place home, every facet of this region has something special to uncover.</p>
            </div><!-- lead__des_wrapper3 -->

            <div class="leadPhotosArea2">
              <img class="lead__photos03 fadeIn" src="../../../assets/luxury_travel/luxury_travel06/lead04.jpg" alt="">
              <img class="lead__photos04 fadeIn" src="../../../assets/luxury_travel/luxury_travel06/lead05.jpg" alt="">
            </div><!-- leadPhotosArea2 -->

          </div><!-- leadSection03 -->

        </section><!-- lead -->



        <!-- Heritage Section ここから -->
        <section class="heritage" id="heritage">

          <div class="heritage__largeImage">
            <video playsinline autoplay muted loop>
              <source src="../../../assets/luxury_travel/luxury_travel06/video/bg_heritage.mp4" type="video/mp4">
            </video>
            <div id="heritage__largeImage__black"></div><!-- heritage__largeImage__black -->
          </div><!-- heritage__largeImage -->


          <div class="heritage_titleArea">
            <h1 class="heritage_title fadeIn" id="heritage_title">Nature and <br>Craftsmanship Working <br>in Harmony</h1>
            <p class="playVideo fadeIn" @click="openStreaksPlayer('3af1b893e9df49b3b9f5a5d00d7c1d61')">
              <img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel06/svg/play_icon.svg" alt="">Play video
            </p>
          </div><!-- heritage_titleArea -->

          <div class="heritageSection01">

            <div class="japanHeritageWrapper">
              <img src="../../../assets/luxury_travel/luxury_travel06/svg/japan_heritage.svg" class="japanHeritage">
            </div><!-- japanHeritageWrapper -->

            <div class="heritage__des001_wrapper">
              <p class="heritage__des001 fadeIn"><i>Tatara</i> ironmaking, a traditional method using iron sand and charcoal, defined Okuizumo’s culture and economic growth.<br><br>With its forest-covered mountains and rivers rich in iron sand, this region was ideal for the production of <i>tamahagane</i>, a type of steel highly valued for crafting Japanese swords. The name <i>tamahagane</i> translates to "precious steel" in English, emphasizing its rarity and significance.</p>
            </div><!-- heritage__des001_wrapper -->

          </div><!-- heritageSection01 -->

          <div class="heritage__largeImage2">
            <img src="../../../assets/luxury_travel/luxury_travel06/large_dammy.png" alt="">
          </div><!-- heritage__largeImage2 -->



        </section><!-- heritage -->


        <section class="heritage_horizon">
          <div class="heritage_horizon_inner">

            <p class="heritage__des1">The 1,400 years of Shimane's steel manufacturing legacy can be explored at the serene village of Sugaya Tatara Sannai. Here, you can admire an example of the type of clay furnace that was used to produce <i>tamahagane</i>.</p>

            <div class="photo_wrapper heritage__photos01">
              <img src="../../../assets/luxury_travel/luxury_travel06/heritage02.jpg" alt="" class="heritage__photos01_inner">
            </div><!-- heritage__photos01 -->

            <div class="photo_wrapper heritage__photos02">
              <img src="../../../assets/luxury_travel/luxury_travel06/heritage03.jpg" alt="" class="heritage__photos02_inner">
            </div><!-- heritage__photos02 -->

            <p class="heritage__des2">The enduring legacy of <i>tatara</i> unites history and nature, creating a seamless blend of culture and beauty. Excavated land was systematically converted into terraced rice fields and has continued to flourish to this day.<br><br>Nearby Ryuzugataki Falls, with its abundant cascade, symbolizes the essential role of water in forging <i>tamahagane</i> steel.</p>


            <div class="photo_wrapper heritage__photos03">
              <img class="heritage__photos03_inner" src="../../../assets/luxury_travel/luxury_travel06/heritage04.jpg" alt="">
            </div><!-- heritage__photos03 -->

            <div class="photo_wrapper heritage__photos04">
              <img class="heritage__photos04_inner" src="../../../assets/luxury_travel/luxury_travel06/heritage05.jpg" alt="">
            </div><!-- heritage__photos04 -->

            <p class="heritage__des3">Venturing further, you'll discover Yoshida-cho, a captivating village where time seems to stand still. Artfully designed architecture, temples, and small businesses echo the richness of the region's past.<br><br> Storehouses built by the Tanabe family, whose business prospered as manufacturers of <i>tamahagane</i>, now serve as the centerpiece of this quaint village.</p>


            <div class="photo_wrapper heritage__photos05">
              <img class="heritage__photos05_inner" src="../../../assets/luxury_travel/luxury_travel06/heritage06.jpg" alt="">
            </div><!-- heritage__photos05 -->

            <div class="photo_wrapper heritage__photos06">
              <img class="heritage__photos06_inner" src="../../../assets/luxury_travel/luxury_travel06/heritage07.jpg" alt="">
            </div><!-- heritage__photos06 -->
          </div><!-- heritage_horizon_inner -->
        </section><!-- heritage_horizon -->

        <!-- Accommodation Section ここから -->
        <section class="accommodation" id="accommodation">

          <div class="accommodation__largeImage">
            <video playsinline autoplay muted loop>
              <source src="../../../assets/luxury_travel/luxury_travel06/video/bg_accommodation.mp4" type="video/mp4">
            </video>
            <div id="accommodation__largeImage__black"></div><!-- accommodation__largeImage__black -->
          </div><!-- accommodation__largeImage -->



          <div class="accommodation__title_wrapper">
            <h2 class="accommodation__title fadeIn">An Elegant Escape<br>Beloved by Japan’s<br>Cultural Icons</h2>
            <p class="playVideo fadeIn" @click="openStreaksPlayer('b3c2efdd20f1482cb1c1f2f789dbe9f9')">
              <img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel06/svg/play_icon.svg" alt="">Play video
            </p>
          </div><!-- accommodation__title_wrapper -->


          <img class="accommodation_tag fadeIn" src="../../../assets/luxury_travel/luxury_travel06/svg/accommodation.svg" alt="Accommodation">

          <div class="accomodation_section00">
            <div class="accommodation__des00_wrapper">
              <p class="accommodation__des fadeIn">Minamikan was once the favored domain of the nation's most influential artists and writers. Established in 1888, this <i>ryokan</i> inn is a tranquil retreat and a true taste of timeless luxury.</p>
            </div>
          </div>
          <!-- accomodation_section00 -->


          <div class="accomodation_section01">

            <div class="accommodation_photo01 fadeIn">
              <img class="accommodation__photos01_inner" src="../../../assets/luxury_travel/luxury_travel06/ac01.jpg" alt="">
              <img class="accommodation__photos02_inner" src="../../../assets/luxury_travel/luxury_travel06/ac02.jpg" alt="">
            </div><!-- accommodation_photo01 -->

            <div class="accommodation__des01_wrapper">
              <p class="accommodation__des fadeIn">With only 16 guest rooms available in this exclusive facility, the elegantly designed accommodation blends the best of both worlds, integrating Western comforts with the essence of Japanese aesthetics.</p>
              <p class="accommodation__des fadeIn">The result is a retro-modern style retreat that stays true to the inn's original design, offering a tranquil haven where guests can indulge in a harmonious fusion of past and present. For an authentic and traditional experience, guests are invited to wear a <i>yukata</i>, a light and casual style kimono.</p>
            </div><!-- accommodation__des_wrapper -->

          </div><!-- accomodation_section01 -->

          <div class="accommodation_largeImageArea">
            <img src="../../../assets/luxury_travel/luxury_travel06/large_dammy.png" alt="">
          </div><!-- accommodation_largeImageArea -->


          <div class="accomodation_section02">

            <div class="accommodation_des02_wrapper">
              <p class="accommodation_des fadeIn">One of the <i>ryokan</i>'s most defining features is the meticulously maintained and beautifully landscaped Japanese garden overlooking Lake Shinji. The garden, featured in international magazines, amazes visitors with the art and precision with which this corner of paradise was created. Each angle and viewpoint offers a fresh perspective on the landscape, leaving one with a deep appreciation for the care and consideration imbued in this <i>ryokan</i>’s design. </p>
            </div><!-- accommodation__des02_wrapper -->

          </div><!-- accomodation_section02 -->

          <div class="accomodation_section03">

            <div class="accommodation_photo02 fadeIn">
              <img class="accommodation__photos04_inner" src="../../../assets/luxury_travel/luxury_travel06/ac04.jpg" alt="">
            </div><!-- accommodation_photo02 -->

          </div><!-- accomodation_section03 -->




        </section><!-- accommodation -->


        <!-- Cuisine Section ここから -->
        <section id="cuisine" class="cuisine">

          <div class="cuisine__largeImage">
            <video playsinline autoplay muted loop>
              <source src="../../../assets/luxury_travel/luxury_travel06/video/bg_cuisine.mp4" type="video/mp4">
            </video>
            <div id="cuisine__largeImage__black"></div><!-- cuisine__largeImage__black -->
          </div><!-- cuisine__largeImage -->

          <img class="cuisine_tag fadeIn" src="../../../assets/luxury_travel/luxury_travel06/svg/cuisine.svg" alt="Cuisine">

          <div class="cuisine__title_wrapper">
            <h2 class="cuisine__title fadeIn">Indulge in<br>Local Specialties and<br>Get a Taste of the Region</h2>
            <p class="playVideo fadeIn" @click="openStreaksPlayer('cfe5131a5349410d8d3baf95a0ada5d9')" >
              <img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel06/svg/play_icon.svg" alt="">Play video
            </p>
          </div><!-- cuisine__title_wrapper -->

          <div class="cuisine_section00">
            <div class="cuisine__des00_wrapper">
              <p class="cuisine__des fadeIn">Culinary artistry is a defining factor of Minamikan, and the head chef carefully prepares a menu of dishes that reflect the region's seasonality, taking advantage of the abundant natural resources of Lake Shinji’s clear waters and the nearby mountains.</p>
            </div>
          </div>
          <!-- cuisine_section00 -->

          <div class="cuisine_section01">

            <div class="cuisine_photo01 fadeIn">
              <img src="../../../assets/luxury_travel/luxury_travel06/cuisine01.jpg" alt="">
              <img src="../../../assets/luxury_travel/luxury_travel06/cuisine02.jpg" alt="">
            </div><!-- cuisine_photo01 -->

            <div class="cuisine__des01_wrapper">
              <p class="cuisine__des fadeIn"> The serving style is <i>kaiseki</i>, a type of Japanese course meal consisting of many small dishes that showcase the chefs’ skills and the diversity of the region's offerings.</p>
            </div><!-- cuisine__des_wrapper -->

          </div><!-- cuisine_section01 -->


          <div class="cuisine_section02">

            <div class="cuisine_photo02 fadeIn">
              <img src="../../../assets/luxury_travel/luxury_travel06/cuisine03.jpg" alt="">
              <img src="../../../assets/luxury_travel/luxury_travel06/cuisine04.jpg" alt="">
            </div><!-- cuisine_photo02 -->

            <div class="cuisine__des03_wrapper">
              <p class="cuisine__des fadeIn">Both single-day visitors and staying guests are welcome to visit the dining space, which looks out onto the garden, and enjoy some of the delicate cuisine Shimane has to offer. One local favorite is <i>taimeshi</i>, a Japanese comfort food of sorts consisting of egg, nori seaweed, wasabi, green onion, and boiled <i>tai</i> sea bream, served upon a bed of pearly white rice. </p>
              <p class="cuisine__des fadeIn">Beautifully presented and subtle in flavor, with the original twist of adding <i>dashi</i> broth and mixing, it’s a simple but well-crafted dish that captures the essence of the region.</p>
            </div><!-- cuisine__des03_wrapper -->

          </div><!-- cuisine_section02 -->

        </section><!-- cuisine -->


        <!-- Experience Section ここから -->
        <section id="experience" class="experience">

          <div class="experience__largeImage">
            <video playsinline autoplay muted loop>
              <source src="../../../assets/luxury_travel/luxury_travel06/video/bg_experience.mp4" type="video/mp4">
            </video>
            <div id="experience__largeImage__black"></div><!-- experience__largeImage__black -->
          </div><!-- experience__largeImage -->

          <div class="experience__title_wrapper">
            <h2 class="experience__title fadeIn">Where the Artisans<br>Keep Japan’s<br> Tradition Alive</h2>
            <p class="playVideo fadeIn" @click="openStreaksPlayer('261a837c4a9f442ea90127980554be48')">
              <img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel06/svg/play_icon.svg" alt="">Play video
            </p>
          </div><!-- experience__title_wrapper -->

          <div class="experienceSection01">
            <div class="experienceTagWrapper">
              <img src="../../../assets/luxury_travel/luxury_travel06/svg/experience.svg" class="experience_tag">
            </div><!-- experienceTagWrapper -->
          </div><!-- experienceSection01 -->

          <div class="experienceSection02">
            <div class="experience__des001_wrapper">
              <p class="experience__des fadeIn">Known as one of the birthplaces of sake culture, the Shimane region’s healthy soil and pure waters create a fertile landscape for high-quality sake production.</p>
            </div><!-- experience__des001_wrapper -->
          </div>
          <!-- experienceSection02 -->

          <div class="experience_largeImageArea">
            <img src="../../../assets/luxury_travel/luxury_travel06/large_dammy.png" alt="">
          </div><!-- experience_largeImageArea -->

          <!-- Experience Horizon ここから -->
          <section class="experience_horizon">
            <div class="experience_horizon_inner">

              <p class="experience__des1">Sake Mochida Honten is overseen by fifth-generation brewer Yusuke Mochida, who preserves centuries-old brewing techniques. The brewery holds a deep commitment to the local community, using locally cultivated Shimane rice to craft their diverse range of sake. This dedication reflects their strong passion for quality and tradition.</p>

              <div class="photo_wrapper experience__photos01">
                <img src="../../../assets/luxury_travel/luxury_travel06/ex02.jpg" alt="" class="experience__photos01_inner">
              </div><!-- experience__photos01 -->

              <div class="photo_wrapper experience__photos02">
                <img src="../../../assets/luxury_travel/luxury_travel06/ex03.jpg" alt="" class="experience__photos02_inner">
              </div><!-- experience__photos02 -->


              <p class="experience__des2">Charmingly furnished with antique items, the building itself holds cultural significance, registered as a Cultural Property in 2017. Yusuke warmly invites guests to savor sake's unique flavor profiles and offers a genuine insight into sake culture through guided tastings.</p>

              <div class="photo_wrapper experience__photos03">
                <img src="../../../assets/luxury_travel/luxury_travel06/ex04.jpg" alt="" class="experience__photos03_inner">
              </div><!-- experience__photos03 -->


              <div class="photo_wrapper experience__photos04">
                <img src="../../../assets/luxury_travel/luxury_travel06/ex05.jpg" alt="" class="experience__photos04_inner">
              </div><!-- experience__photos04 -->

              <p class="experience__des3">Explore the living tradition of ironmaking at atelier Kajikobo Hiromitsu, run by the Koto family for 200 years. Using classic swordsmithing techniques, they craft artisan home goods such as candleholders, lanterns, and their iconic "blacksmith's frying pan" sought after from all over Japan.</p>

              <div class="photo_wrapper experience__photos05">
                <img src="../../../assets/luxury_travel/luxury_travel06/ex06.jpg" alt="" class="experience__photos05_inner">
              </div><!-- experience__photos05 -->

              <p class="experience__des4">Be immersed in the world of <i>shokunin</i>, skilled artisans, at the workshop behind the atelier. Get a firsthand understanding of their mastery as they offer hands-on experiences, allowing guests to touch and examine the products as they’re made. Visits are available by reservation only, so be sure to coordinate the timing in advance for a memorable adventure.</p>

              <div class="photo_wrapper experience__photos06">
                <img src="../../../assets/luxury_travel/luxury_travel06/ex07.jpg" alt="" class="experience__photos06_inner">
              </div><!-- experience__photos06 -->

              <p class="experience__des5">As brother and sister work hard under the watchful eye of their 80-plus-year-old father, there is so much to discover about hospitality, family dynamics, and Shimane’s artisan legacy. They are passionate about sharing their life’s work, and a visit here is like being welcomed into a new family.</p>


            </div><!-- experience_horizon_inner -->
          </section><!-- experience_horizon -->

        </section><!-- experience -->


        <div class="maplinkArea">
          <a class="maplink" href="https://www.google.com/maps/d/viewer?hl=en&hl=en&mid=1RM-zOk9TYJBez4hTRqhlFhLhxl433Fc&ll=35.175010679787576%2C133.07661369799803&z=13" target="_blank">See on map <img src="../../../assets/luxury_travel/luxury_travel06/svg/outerlink.svg"></a>
        </div><!-- maplinkArea -->

        <Questionnaire :page-id="pageId" />
        <!-- See other luxury destinations ここから -->
          <SeeOtherLuxury />
        <!-- See other luxury destinations ここまで -->

        <!-- Nearby Japan Heritage Sites 挿入箇所 -->

        <!-- Other Sites in Same Category 挿入箇所 -->

        <!-- 特集Specialコンテンツここまで -->
        <streaks-player ref="streaks"></streaks-player>
      </main>
    </div>
</template>

<script>
import StreaksPlayer from "@/components/StreaksPlayer/StreaksPlayer";
import ApiRouter from "@/components/Systems/ApiRouter";
import SeeOtherLuxury from "../SeeOtherLuxury";
import "video.js/dist/video-js.css";
import Questionnaire from "../Questionnaire.vue";
import JsonLd from "@/components/JsonLd/JsonLd.vue";

export default {
  name: "LuxuryTravel06",
  components: {JsonLd, Questionnaire, StreaksPlayer, SeeOtherLuxury },
  mixins: [ApiRouter],
  data: function () {
    return {
      publicPath: `${process.env.VUE_APP_PUBLIC_PATH}`,
      pageId: '6',
        jsonld: {
            "@context": "https://schema.org",
            "@type": "Article",
            "mainEntityOfPage": window.location.href,
            "headline": "Forged in Time: Uncovering Okuizumo's Steel Heritage",
            "description": "Japan Heritage ties together historical sites, shrines, temples, traditional arts, castles, armor," +
                "and other cultural assets. Find photos, videos, tourist information, and more.",
            "image": [
                require('../../../assets/luxury_travel/index/luxury06.jpg')
            ],
            "datePublished": "2023/10/10",
            "dateModified": "2023/12/19",
            "author": [{
                "@type": "Organization",
                "name": "Japan National Tourism Organization",
                "url": "https://www.japan.travel/japan-heritage/"
            }]
        }
    };
  },
  mounted: function () {
    document.title = 'Japan Heritage Official Site | Stories and travel information | JNTO'
    let url = this.publicPath + "js/luxurytravel/luxurytravel06.js";
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute("src", url);
    document.head.appendChild(recaptchaScript);
  },
  methods: {
    openStreaksPlayer: function (id) {
      this.$refs.streaks.open(id);
    },
  },
}
</script>

<style src="./LuxuryTravel06.scss" lang="scss" scoped/>
